import styled, { keyframes, css } from 'styled-components'
import { theme } from '../utils/theme'

const likeAnim = keyframes`
  0% {
    transform: scale(0.3);
    fill: ${theme.colors.red[600]};
    color: ${theme.colors.red[600]};
  }
  60% {
    transform: scale(1.2);
    fill: ${theme.colors.red[600]};
    color: ${theme.colors.red[600]};
  }
  80% {
    transform: scale(0.9);
    fill: ${theme.colors.red[600]};
    color: ${theme.colors.red[600]};
  }
  100% {
    transform: scale(1);
    fill: ${theme.colors.red[600]};
    color: ${theme.colors.red[600]};
  }
`

type Props = {
  isLiked?: boolean;
}

const StyledPhotoPreviewItem = styled.div<Props>`
  position: relative;
  cursor: pointer;
  transition: box-shadow 0.2s;
  height: 235px;
  width: 296px;
  flex-shrink: 0;

  &:not(:last-child) {
    margin-right: 1rem;
  }

  .photo-preview-image {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    overflow: hidden;
    bottom: 0;
    border-radius: 3px;

    &::after {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      content: '';
      border: 1px solid #0000000f;
      border-radius: 3px;
      pointer-events: none;
    }

    img {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .actions-row {
    display: flex;
    align-items: center;
    right: 12px;
    top: 12px;
    position: absolute;

    .new-label {
      font-weight: 600;
      align-items: center;
      font-size: 14px;
      line-height: 24px;
      flex-shrink: 0;
      height: 28px;
      padding: 0 8px;
      user-select: none;
      pointer-events: none;
      border-radius: 6px;
      display: flex;
      letter-spacing: 0.02rem;
      justify-content: center;
      overflow: hidden;
      background-color: ${({ theme }) => theme.colors.green[500]};
      color: ${({ theme }) => theme.colors.background};
      box-shadow: inset 0 0 0 1px #00000021;
    }

    button {
      margin-left: 6px;
    }
  }

  button {
    height: 34px;
    display: flex;
    position: absolute;
    align-items: center;
    border: none;
    background-color: transparent;
    padding: 0;
    transition: 0.2s;
    pointer-events: all;
    user-select: none;
    border-radius: 6px;

    &:hover {
      cursor: pointer;
    }
  }

  .admin-btn {
    height: 28px;
    width: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    position: relative;
    border: 0;
    padding: 0;
    transition: background-color 0.2s;
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.gray[600]};
    box-shadow: 0 0 0 1px #00000021;

    svg {
      height: 20px;
    }

    &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.colors.gray[200]};
    }
  }

  .use-btn,
  .delete-btn {
    padding: 0 10px;
    left: 12px;
    bottom: 12px;
    font-weight: 600;
    user-select: none;
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.gray[600]};
    box-shadow: 0 0 0 1px #00000021;

    span {
      position: relative;
      top: 1px;
    }

    svg {
      height: 18px;
      margin-right: 8px;
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.gray[200]};
    }
  }

  .fav-btn {
    width: 34px;
    right: 12px;
    bottom: 12px;
    justify-content: center;
    color: ${({ theme }) => theme.colors.background};

    svg {
      height: 26px;
      filter: ${({ isLiked }) => (isLiked ? 'none' : 'drop-shadow(0 0 1px #0000009c)')};

      ${({ isLiked }) =>
    isLiked &&
        css`
          animation: ${likeAnim} forwards 0.2s ease-in-out;
        `}

      path {
        stroke-width: 1.7px;
      }
    }

    &:hover {
      background-color: ${({ isLiked, theme }) =>
    (isLiked ? `${theme.colors.red[600]}20` : `${theme.colors.background}50`)};
    }
  }
`

export default StyledPhotoPreviewItem
